const BOARD_IDS = [
  "ef02168e-7718-11e9-97c3-000c29344ed7",
  "b521765c-b4b2-4b92-8f8f-7862a5e0f315",
];

const BOARD_TEXT = ["10th Class (X)", "12th Class (XII)"];

export const shouldShowBoardScreen = (
  id?: string | null,
  qualificationText?: string | null,
): boolean => {
  if (id && BOARD_IDS.includes(id)) {
    return true;
  }

  if (qualificationText && BOARD_TEXT.includes(qualificationText)) {
    return true;
  }

  return false;
};
